import React, { useState } from 'react';
import './pannelli.css';

/**
 * Una sezione richiudibile della pagina di accettazione.
 *
 * E' il <details> nativo e non un componente con uno stato suo: apre e chiude da solo, risponde
 * alla tastiera, e il browser ci trova dentro il testo. Lo stesso meccanismo che usa gia'
 * TabApprovazioni.
 *
 * Il sommario resta visibile da chiuso: e' quello che rende utile un pannello che non si apre.
 *
 * Il contenuto si monta alla prima apertura. Un pannello chiuso che costruisce comunque una
 * tabella da cinquanta righe, o che fa partire Leaflet, e' esattamente lo spreco che questa
 * pagina ha gia' tolto una volta dal caricamento. Una volta aperto resta montato: riaprirlo e'
 * immediato e non ricomincia da capo.
 */
const Pannello = ({ icona, titolo, sommario, aperto = false, children }) => {
  // Lo stato dell'apertura lo tiene React, non il solo DOM: con open={aperto} fisso, un
  // aggiornamento del padre richiuderebbe il pannello che l'utente aveva aperto.
  const [apertoOra, setApertoOra] = useState(aperto);
  const [maiAperto, setMaiAperto] = useState(aperto);

  const cambia = (evento) => {
    const adesso = evento.currentTarget.open;
    setApertoOra(adesso);
    if (adesso) setMaiAperto(true);
  };

  return (
    <details className="pannello" open={apertoOra} onToggle={cambia}>
      <summary className="pannello-testa">
        <i className={`fas ${icona} pannello-icona`}></i>
        <span className="pannello-titolo">{titolo}</span>
        {sommario && <span className="pannello-sommario">{sommario}</span>}
      </summary>
      <div className="pannello-corpo">{maiAperto ? children : null}</div>
    </details>
  );
};

export default Pannello;
